/* eslint-disable react/jsx-sort-props */
import type { FC } from 'react';
import { Fragment } from 'react';
import type { SEOEntity } from '../../@types/gql/seo';
import logo from '../../images/logoNew.png';

const SEOComponent: FC<{ seo?: SEOEntity }> = ({ seo }) => {
  if (!seo)
    return <title>Sahil Machines and Alloys | Crafting the Future</title>;

  const {
    metaTitle,
    metaDescription,
    metaImage,
    metaSocial,
    keywords,
    metaRobots,
    structuredData,
  } = seo;

  const currentPageUrl =
    typeof window !== 'undefined' ? window.location.href : '';

  // Check if the current path is '/contact'
  const isContactPage =
    currentPageUrl.split('/').filter(Boolean).pop() === 'contact-us';


    // Static organization schema
  // const organizationSchema = {
  //   "@context": "https://schema.org",
  //   "@type": "Organization",
  //   "name": "Sahil CNC Machines",
  //   "url": "https://www.sahilcnc.com",
  //   "sameAs": [
  //     "https://www.linkedin.com/company/sahil-cnc-machines/",
  //     "https://www.youtube.com/@sahilcncmachines",
  //     "https://x.com/SahilCNC",
  //     "https://www.facebook.com/people/Sahil-CNC-Machines/61556416797746/",
  //     "https://www.instagram.com/sahilcncmachines/",
  //     "https://www.pinterest.com/sahilmachine/",
  //     "https://www.flickr.com/photos/sahilmachines/",
  //     "https://medium.com/@sales_10867",
  //     "https://wa.me/918427641925",
  //     "https://www.slideshare.net/sales454631"
  //   ]
  // };

  return (
    <>
      <title>{metaTitle}</title>

{/* <meta name="p:domain_verify" content="7beca57eb31aa7690331193e739dc404"/> */}
      {!isContactPage && (
        <meta
          name="p:domain_verify"
          content="7beca57eb31aa7690331193e739dc404"
        />
      )}

      {metaDescription ? (
        <meta content={metaDescription} name="description" />
      ) : null}
      {metaImage ? <meta content={metaImage.url} property="og:image" /> : null}
      {/* {metaSocial?.map((social, index) => (
        <Fragment key={`key-${index.toString()}`}>
          {social.title ? (
            <meta content={social.title} property="og:title" />
          ) : null}
          {social.description ? (
            <meta content={social.description} property="og:description" />
          ) : null}
          {social.image ? (
            <meta content={social.image.url} property="og:image" />
          ) : null}
           {currentPageUrl ? <link href={currentPageUrl} rel="canonical" /> : null}
        </Fragment>
      ))} */}

      {metaSocial?.map((social, index) =>
        social.socialNetwork === 'Facebook' ? (
          <Fragment key={`key-${index.toString()}`}>
            {social.title ? (
              <meta content={social.title} property="og:title" />
            ) : null}
            {social.description ? (
              <meta content={social.description} property="og:description" />
            ) : null}
            {social.image ? (
              <meta content={social.image.url || logo} property="og:image" />
            ) : null}
            {currentPageUrl ? (
              // eslint-disable-next-line react/no-unknown-property
              <link href={currentPageUrl} property="og:url" />
            ) : null}
          </Fragment>
        ) : (
          <Fragment key={`key-${index.toString()}`}>
            <meta name="twitter:card" content="summary_large_image" />
            <meta property="twitter:domain" content="sahilcnc.com" />
            <meta property="twitter:url" content={currentPageUrl} />
            <meta name="twitter:title" content={social.title} />
            <meta name="twitter:description" content={social.description} />
            <meta name="twitter:image" content={social.image?.url || logo} />
          </Fragment>
        ),
      )}
      {keywords ? <meta content={keywords} name="keywords" /> : null}
      {metaRobots ? <meta content={metaRobots} name="robots" /> : null}
      {structuredData ? (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      ) : null}

        {/* Add organization structured data */}
      {/* <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script> */}

      {currentPageUrl ? <link href={currentPageUrl} rel="canonical" /> : null}
    </>
  );
};

export default SEOComponent;
